// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".cd975d73c6134415608c10b4b61053551d116280.chunk.js";
};